/* Convivium — "Aggiungi" handler for marketplace-style product cards rendered
   outside the marketplace page (search results, collection grids).
   The marketplace page binds its own handler on #mp-products-grid, so clicks
   inside that grid are ignored here to avoid double adds. */

(function () {

  /* Il riquadro sta in cv-carrello.js, che il layout carica su ogni pagina.
     Prima ogni file aveva la sua copia di questa funzione: tre copie identiche
     che il giorno che se ne cambiava una sola cominciavano a divergere. */
  function showToast(msg, isError) {
    if (window.Convivium && window.Convivium.toast) window.Convivium.toast(msg, isError);
  }

  /* Dispatch Horizon's cart:update so cart-icon, cart-drawer, etc. refresh */
  function dispatchCartUpdate(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'mp-card-add',
        data: {
          source: 'mp-card-add',
          itemCount: cart ? cart.item_count : 0,
        },
      },
    }));
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.mp-prod-card__add');
    if (!btn || btn.disabled) return;
    if (btn.closest('#mp-products-grid')) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('mp-prod-card__add--loading');
    var origText = btn.textContent;
    btn.textContent = 'Aggiunta...';
    btn.disabled = true;

    try {
      var card = btn.closest('.mp-prod-card');
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId, 10),
            quantity: 1,
            properties: { _vendor_group: (card && card.getAttribute('data-vendor')) || '' },
          }],
        }),
      });

      if (!res.ok) {
        var err = await res.json().catch(function () { return {}; });
        throw new Error(err.description || 'Errore');
      }

      var cartRes = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      var cart = cartRes.ok ? await cartRes.json() : null;
      dispatchCartUpdate(cart);
      showToast('Prodotto aggiunto al carrello');
    } catch (err) {
      showToast(err.message || 'Errore: riprova', true);
    } finally {
      btn.classList.remove('mp-prod-card__add--loading');
      btn.textContent = origText;
      btn.disabled = false;
    }
  });
})();
